import { useContext, useState, FC, useEffect } from 'react'

import CustomFormCommonEntityPropsManagerContext from './Context'
import readCommonEntitiesOnCustomForm from './services/readCommonEntitiesOnCustomForm'
import { CustomFormCommonEntity, CustomFormCommonEntityFilter } from '../../types'
import { CustomFormCommonEntitiesProps } from '../..'
import { Pagination } from 'types'

type Props = CustomFormCommonEntitiesProps & {
  children: JSX.Element
}

const CustomFormCommonEntityPropsManagerProvider: FC<Props> = ({
  children,
  defaultView = 'SELECT_ENTITY',
  ...props
}) => {
  const [view, setView] = useState<string>(defaultView)
  const [selectedEntity, setSelectedEntity] = useState<CustomFormCommonEntity>({})
  const [loadingEntities, setLoadingEntities] = useState<boolean>(true)
  const [entities, setEntities] = useState<CustomFormCommonEntity[]>([])
  const [invalidEntity, setInvalidEntity] = useState<boolean>(false)
  const [totalEntities, setTotalEntities] = useState<number>(0)
  const [filter, setFilter] = useState<CustomFormCommonEntityFilter>({ name: '', state_name: '' })
  const [pagination, setPagination] = useState<Pagination>({ page: 1, limit: 100, sort: { order: 'ASC', by: 'name' } })

  async function loadCommonEntities() {
    setLoadingEntities(true)
    const filters = {
      filter,
      pagination,
    }

    const response = await readCommonEntitiesOnCustomForm({ entityKey: props.currentEntity.keyPlural, filters })

    if (response?.header?.success) {
      const entitiesFromAPI = response?.body?.[props.currentEntity.key]?.elements
      const totalElementsFromAPI = response?.body?.[props.currentEntity.key]?.totalElements
      setEntities(entitiesFromAPI || [])
      setTotalEntities(totalElementsFromAPI || 0)
      setInvalidEntity(false)
    } else {
      setInvalidEntity(true)
    }
    setLoadingEntities(false)
  }

  useEffect(() => {
    if (view != 'SEARCH_ENTITY') loadCommonEntities()
  }, [filter, pagination])

  return (
    <CustomFormCommonEntityPropsManagerContext.Provider
      value={{
        defaultView,
        view,
        setView,
        selectedEntity,
        setSelectedEntity,
        filter,
        setFilter,
        entities,
        loadingEntities,
        setLoadingEntities,
        invalidEntity,
        pagination,
        setPagination,
        totalEntities,
        ...props,
      }}
    >
      {children}
    </CustomFormCommonEntityPropsManagerContext.Provider>
  )
}

export const useCustomFormCommonEntityPropsManager = () => useContext(CustomFormCommonEntityPropsManagerContext)

export default CustomFormCommonEntityPropsManagerProvider
